const fetchCakes = async () => {
  const res = await fetch(
    `https://api.jsonbin.io/v3/b/${process.env.REACT_APP_CAKES_BIN_ID}`,
    {
      method: "GET",
      headers: {
        "X-Master-Key":
          "$2a$10$jNtgKWEqFsk8F.nyMllFdeKYpt6pE0xv5653.ySygQXe7WQ4ZiFpK",
      },
    },
  );
  const data = await res.json();
  return data.record;
};

export default fetchCakes;
